import { DataService, PublicService } from "base/services";
import { useAccountStore } from "base/stores";

export const LoginService = {
  login: (data) => {
    const { _id } = useAccountStore.getState();

    return PublicService.post(`/signin/2/${_id}/`, {
      data,
      options: {
        recaptcha_action: "loginrequest"
      },
      toast: false
    });
  },
  join: (data) => {
    const { _id } = useAccountStore.getState();
    return PublicService.post(`/user/2/${_id}/join`, {
      data,
      options: {
        recaptcha_action: "joinrequest"
      },
      toast: false
    });
  },
  forgotPassword: (data) => {
    const { _id } = useAccountStore.getState();
    return PublicService.post(`/signin/2/${_id}/password/forgot`, {
      data,
      options: {
        recaptcha_action: "forgotpassword"
      },
      toast: false
    });
  },
  requestAccess: (data) => {
    const { _id } = useAccountStore.getState();

    return PublicService.post(`/user/2/${_id}/${data.userId}/request/access`, {
      data: {},
      toast: true,
      options: {
        recaptcha_action: "requestaccess"
      }
    });
  },
  updateTwoFactorType: (type) => {
    const { _id } = useAccountStore.getState();
    return PublicService.post(`/signin/2/${_id}/otp/${type}`, {
      options: {
        recaptcha_action: "twofactortype"
      }
    });
  },
  verifyOTP: (type, data) => {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/signin/2/${_id}/otp/${type}/verify`, {
      data
    });
  },
  resetPassword: (credential) => {
    const { _id } = useAccountStore.getState();
    return PublicService.post(`/signin/2/${_id}/password/reset`, {
      data: credential,
      options: {
        recaptcha_action: "resetrequest"
      },
      toast: false
    });
  },

  setPassword: (credential) => {
    const { _id } = useAccountStore.getState();
    return PublicService.post(`/signin/2/${_id}/password/set`, {
      data: credential,
      options: {
        recaptcha_action: "setpassword"
      },
      toast: false
    });
  },
  setGoogleAuthCode: (code) => {
    const { _id } = useAccountStore.getState();

    return DataService.post(`/signin/2/${_id}/google`, {
      data: code
    });
  },
  verifyBotToken(data, provider) {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/bot/2/${_id}/${provider}/consent`, {
      data
    });
  }
};
